import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "../styles/components/costumers.sass";

const logos = [
  "/logos/ata_logo.png",
  "/logos/atelie_logo.png",
  "/logos/catmetal_logo.png",
  "/logos/leme_logo.png",
  "/logos/oz_logo.png",
];

export default function Costumers() {
  const settings = {
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
    <section className="logoSection">
      <h2>Conheça alguns dos nossos clientes</h2>
      <Slider {...settings}>
        {logos.map((logo, index) => (
          <div key={index} className="slide">
            <img src={logo} alt={`Logo ${index}`} />
          </div>
        ))}
      </Slider>
    </section>
  );
}
